import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=08eb22f8&scoped=true"
import script from "./DraggableWrapper.vue?vue&type=script&lang=js"
export * from "./DraggableWrapper.vue?vue&type=script&lang=js"
import style0 from "./DraggableWrapper.vue?vue&type=style&index=0&id=08eb22f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb22f8",
  null
  
)

export default component.exports